import { render, staticRenderFns } from "./TcWelcome.vue?vue&type=template&id=447da073&"
import script from "./TcWelcome.vue?vue&type=script&lang=js&"
export * from "./TcWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447da073')) {
      api.createRecord('447da073', component.options)
    } else {
      api.reload('447da073', component.options)
    }
    module.hot.accept("./TcWelcome.vue?vue&type=template&id=447da073&", function () {
      api.rerender('447da073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcWelcome.vue"
export default component.exports